import { socialTwitter } from 'react-icons-kit/ionicons/socialTwitter';
import { socialFacebook } from 'react-icons-kit/ionicons/socialFacebook';
import { socialDribbbleOutline } from 'react-icons-kit/ionicons/socialDribbbleOutline';

export const SOCIAL_PROFILES = [
  {
    id: '1',
    icon: socialTwitter,
    url: '/one',
  },
  {
    id: '2',
    icon: socialFacebook,
    url: '/one',
  },
  {
    id: '3',
    icon: socialDribbbleOutline,
    url: '/one',
  },
];
